import { useTranslation } from 'react-i18next';
import { isDescribedScope } from '../scopes';

export interface ScopeListProps {
  scopes: string[];
  testId: string;
  labelledBy: string;
}

/**
 * Renders a scope in plain language when it's one this screen knows how to
 * describe (`DESCRIBED_SCOPES`), and as a raw `<code>` identifier otherwise —
 * so an undescribed scope reads as a raw identifier rather than as a
 * sentence someone wrote badly. Described scopes lead; within each group the
 * backend's own order is kept, since the order the client requested them in
 * carries meaning.
 */
export function ScopeList({ scopes, testId, labelledBy }: ScopeListProps) {
  const { t } = useTranslation('connected-apps');
  const described = scopes.filter((s) => isDescribedScope(s));
  const undescribed = scopes.filter((s) => !isDescribedScope(s));
  const ordered = [...described, ...undescribed];

  return (
    <ul data-testid={testId} aria-labelledby={labelledBy}>
      {ordered.map((scope, i) => (
        <li key={`${scope}-${i}`}>
          {isDescribedScope(scope) ? t(`scope.${scope}`) : <code>{scope}</code>}
        </li>
      ))}
    </ul>
  );
}
